/* eslint-disable no-undef */
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from '../reducers';
import rootSaga from '../sagas';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer, // rootReducer
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware), // Add sagaMiddleware to default middleware
  devTools:
    process.env.NODE_ENV !== 'production' ||
    process.env.REACT_APP_ENV !== 'production'
});

sagaMiddleware.run(rootSaga);

export default store;
